import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.analysis.widget.category');
import { OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-analysis-widget-category',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.analysis.widget.category/view.scss */
/* src/app/portal.analysis.widget.category/view.scss: no such file or directory */`],
})
export class PortalAnalysisWidgetCategoryComponent implements OnInit, OnChanges {
    @Input() data!: ResearcherData;
    @Input() period: any;

    public researcher: any[];
    public products: any[];
    public periodStart = 0;
    public periodEnd = 0;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['period']) {
            const curr = changes['period'].currentValue;
            this.periodStart = curr?.start;
            this.periodEnd = curr?.end;
            this.loadData();
        }
    }

    constructor(@Inject( Service) private service: Service) { }

    achieveData = [
        { label: '논문', value: 0 },
        { label: '특허', value: 0 },
        { label: '보고서', value: 0 },
    ];

    chartPie: Chart | null = null;

    public async ngOnInit() {
        await this.service.init();
        this.mapping();
        this.loadData();
        await this.service.render();
    }

    public mapping() {
        this.researcher = this.data.researcher;
        this.periodEnd = this.data.period.end;
        this.periodStart = this.data.period.start;
        this.products = this.data.products;
        this.service.render();
    }

    private loadData() {
        if (!this.products) return;

        // 1) 기간 내 products만 필터링
        const filtered = this.products.filter(p => {
            const year = Number(p.pub_year);
            return year >= this.periodStart && year <= this.periodEnd;
        });

        // 카테고리별 분류
        const papers = filtered.filter(p => p.category === 'paper');
        const patents = filtered.filter(p => p.category === 'patent');
        const reports = filtered.filter(p => p.category === 'report');

        // --- 세부 분류 집계 ---
        const paperDetails: Record<string, number> = {};
        for (const p of papers) {
            // const key = p.kr_journal?.trim() || p.en_journal?.trim() || '기타';
            const key = '논문';
            paperDetails[key] = (paperDetails[key] || 0) + 1;
        }

        const patentDetails: Record<string, number> = {};
        for (const p of patents) {
            // TODO: 국내/국제 구분 로직이 있으면 반영
            // const key = p.kr_publisher?.trim() || p.en_publisher?.trim() || '특허';
            const key = '특허';
            patentDetails[key] = (patentDetails[key] || 0) + 1;
        }

        const reportDetails: Record<string, number> = {};
        for (const p of reports) {
            // const key = p.kr_publisher?.trim() || p.en_publisher?.trim() || '보고서';
            const key = '보고서';
            reportDetails[key] = (reportDetails[key] || 0) + 1;
        }

        // --- 상위 카테고리별 합산 ---
        this.achieveData = [
            { label: '논문', value: papers.length },
            { label: '특허', value: patents.length },
            { label: '보고서', value: reports.length },
        ];

        // --- 차트에 넣을 details 구조 ---
        const datasetDetails: any = {
            '논문': Object.entries(paperDetails).map(([label, value]) => ({ label, value })),
            '특허': Object.entries(patentDetails).map(([label, value]) => ({ label, value })),
            '보고서': Object.entries(reportDetails).map(([label, value]) => ({ label, value })),
        };

        this.renderChart(datasetDetails);
    }

    private renderChart(details: any): void {
        if (this.chartPie) this.chartPie.destroy();
        this.chartPie = new Chart('pieChart', {
            type: 'pie',
            data: {
                labels: this.achieveData.map(d => d.label),
                datasets: [{
                    data: this.achieveData.map(d => d.value),
                    backgroundColor: ['#5381F2', '#4FD1B8', '#FFBCF9'],
                    borderWidth: 0,
                    details: details
                }]
            },
            options: {
                responsive: true,
                plugins: {
                    tooltip: {
                        enabled: false,
                        external: (ctx) => this.renderCustomTooltip(ctx)
                    },
                    legend: {
                        display: true,
                        position: 'bottom',
                        labels: {
                            usePointStyle: true,
                            boxWidth: 7,
                            boxHeight: 7,
                            color: '#707988',
                            font: {
                                size: 14,
                            },
                            padding: 14,
                        }
                    }
                }
            }
        } as ChartConfiguration);
    }

    // 커스텀 hover 툴팁
    private renderCustomTooltip(context: any) {
        let tooltipEl = document.getElementById('chartjs-custom-tooltip');
        if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-custom-tooltip';
            tooltipEl.className = 'rounded-lg shadow-[0px_3px_15px_#1A2C7633] bg-white p-2';
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.pointerEvents = 'none';
            tooltipEl.style.zIndex = '1000';
            document.body.appendChild(tooltipEl);
        }

        const { chart, tooltip } = context;

        if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = '0';
            return;
        }

        const dataset: any = chart.data.datasets[0];
        const label = tooltip.dataPoints?.[0]?.label;

        let innerHtml = '<div class="flex flex-col gap-1">';
        if (dataset.details && dataset.details[label]) {
            dataset.details[label].forEach((d: any) => {
                innerHtml += `
                    <div class="flex justify-between gap-4 text-[14px] leading-[18px]">
                        <span class="text-[#707988]">${d.label}</span>
                        <span class="font-semibold">${d.value}건</span>
                    </div>`;
            });
        }
        innerHtml += '</div>';

        tooltipEl.innerHTML = innerHtml;

        const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
        tooltipEl.style.opacity = '1';
        tooltipEl.style.left = positionX + tooltip.caretX + 'px';
        tooltipEl.style.top = positionY + tooltip.caretY + 'px';
    }

}

export default PortalAnalysisWidgetCategoryComponent;